// Copyright (c) 2016 Deere & Company

export const isCommentValid = (prevValue, newValue) => prevValue || (/\w+/).test(newValue);
